<template>
    <div class="course-whiteboard-slide p-4">
        <h3 class="text-center">
            {{blockData.question}}
        </h3>
        <b-form-textarea
            v-if="blockData.lineType === 'multi'"
            v-model="quizAnswer"
            :disabled="hasAnswered || submitting"
            :placeholder="$t('freeTextPlaceholder')"
            class="mt-3"
            style="field-sizing: content;min-height: 100px;"
        ></b-form-textarea>
        <b-form-input
            v-else
            v-model="quizAnswer"
            :disabled="hasAnswered || submitting"
            :placeholder="$t('freeTextPlaceholder')"
            class="mt-3"
        ></b-form-input>
        <b-button
                v-if="!hasAnswered"
                block
                variant="primary"
                class="p-3 quiz-submit mt-3 d-inline-flex align-items-center justify-content-center"
                @click="submitAnswers"
                :disabled="quizAnswer.length === 0 ? true : submitting"
            >
                <b-spinner v-if="submitting" small class="mr-2" style="color: var(--contrast);" />
                {{ $t('submit') }}
        </b-button>
    </div>
</template>

<script>
import CourseBlockMixin from '@/mixins/CourseBlockMixin';
export default {
    name: 'FreeTextBlock',
    components: {},
    mixins: [
        CourseBlockMixin,
    ],
    props: {
        id:{
            type: Number,
            default: null
        },
        module:{
            type: Number,
            default: null
        },
        lesson:{
            type: Number,
            default: null
        },
        slideNum:{
            type: Number,
            default: null
        },
        submitHandler: {
            type: Function,
            default: null,
        }
    },
    data() {
        return {
            quizAnswer: '',
            hasAnswered: false,
            submitting: false,
        };
    },
    mounted() {
        if (this.blockData.answer){
            this.quizAnswer = this.blockData.answer;
            this.hasAnswered = true;
        }
    },
    methods:{
        async submitAnswers(){
            if (!this.submitHandler || this.submitting) {
                return;
            }
            this.submitting = true;
            try {
                await this.submitHandler(this.id, 'free-text', this.quizAnswer);
                this.hasAnswered = true;
                this.blockData.answer = this.quizAnswer;
            } catch (error) {
                this.submitting = false;
                return;
            }
        },
    },
};
</script>
